/**
 * Carte d un document CEE pour la page detail :
 *  - Header : libelle type + status pill
 *  - Si fichier : nom + taille
 *  - Actions (Valider / Rejeter / Telecharger / Previsualiser / Remplacer)
 *  - Si pas de fichier : zone d upload manuel
 *  - Preview PDF inline si toggle (iframe)
 *
 * Le composant est "presentational" : reÃ§oit doc + dispatchers depuis le parent.
 *
 * @param {{
 *   typeKey: string,
 *   typeLabel: string,
 *   typeDescription: string,
 *   doc: object | null,
 *   downloadUrl: string,
 *   isPreviewing: boolean,
 *   busy?: boolean,
 *   readOnly?: boolean,
 *   onValidate: () => void,
 *   onReject: () => void,
 *   onUpload: (file: File) => void,
 *   onSupersede: () => void,
 *   onPreviewToggle: () => void,
 * }} props
 */

import DocActions from './DocActions.jsx';
import UploadDropzone from './UploadDropzone.jsx';
import { pillStyle } from '../lib/pillStyle.js';
import { formatBytes } from '../lib/formatBytes.js';

const STATUS_LABEL = {
  manquant: 'Manquant',
  a_valider: 'A valider',
  valide: 'Valide',
  rejete: 'Rejete',
  superseded: 'Remplace',
  na: 'Non applicable',
};

export default function DocCard({
  typeKey,
  typeLabel,
  typeDescription,
  doc,
  downloadUrl,
  isPreviewing,
  busy = false,
  readOnly = false,
  canValidateAsPartner = false,
  onValidate,
  onReject,
  onUpload,
  onSupersede,
  onPreviewToggle,
}) {
  const status = doc ? doc.status : 'manquant';
  const { cls } = pillStyle(status === 'superseded' ? 'na' : status);
  const label = STATUS_LABEL[status] || status;

  return (
    <div className="bg-white rounded-xl border border-gray-100 p-4 shadow-sm" data-doc-type={typeKey}>
      <div className="flex items-start justify-between gap-2 mb-1">
        <div>
          <h3 className="text-sm font-semibold text-[#0f172a]">{typeLabel}</h3>
          <p className="text-[11px] text-[#94a3b8]">{typeDescription}</p>
        </div>
        <span className={`text-[10px] uppercase tracking-wide px-2 py-1 rounded-md font-bold ${cls}`}>
          {label}
        </span>
      </div>

      {doc && doc.filename && (
        <div className="mt-2 text-xs text-[#475569]">
          <div className="font-medium truncate" title={doc.filename}>{doc.filename}</div>
          <div className="text-[#94a3b8]">
            {formatBytes(doc.sizeBytes)}{doc.source ? ` · ${doc.source}` : ''}
          </div>
        </div>
      )}

      {doc ? (
        <>
          <DocActions
            doc={doc}
            onValidate={onValidate}
            onReject={onReject}
            onSupersede={onSupersede}
            onPreviewToggle={onPreviewToggle}
            downloadHref={downloadUrl}
            isPreviewing={isPreviewing}
            busy={busy}
            readOnly={readOnly}
            canValidateAsPartner={canValidateAsPartner}
          />
          {isPreviewing && (
            <iframe
              src={downloadUrl}
              title={`Apercu ${typeLabel}`}
              className="w-full h-80 mt-3 border border-gray-100 rounded-lg"
            />
          )}
        </>
      ) : (
        !readOnly && <div className="mt-3">
          <UploadDropzone onFile={onUpload} compact disabled={busy} />
        </div>
      )}
    </div>
  );
}
